import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/reset.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { unstableSetRender } from 'antd';
import { createRoot } from 'react-dom/client';
import { loadConfig } from './shared/config/runtime.config';
import { initApiService } from './shared/services/api/api.service';
// PWA removed: ensure any existing service workers are unregistered and caches cleared

unstableSetRender((node, container: any) => {
  container._reactRoot ||= createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Load configuration before rendering the app
loadConfig()
  .then(config => {
    // initializations
    initApiService(config);
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App/>
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error('Failed to load configuration:', err);
    throw new Error('Failed to load runtime configuration');
  });

// Cleanup any previously installed service workers and caches
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((reg) => reg.unregister()))
    .catch(() => {});
}
try {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cachesApi = (window as any).caches as CacheStorage | undefined;
  if (cachesApi && typeof cachesApi.keys === 'function') {
    cachesApi.keys().then((keys: string[]) => {
      keys.forEach((k) => cachesApi.delete(k));
    }).catch(() => {});
  }
} catch (e) {}

reportWebVitals();
